<template>
  <Space space="operatorSpace" />
</template>
<script>
import Space from "../components/space.vue";
export default {
  components: { Space },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>